import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'What is the history of the 91311 area?',
  answer: 'The Chumash people lived here for over 10,000 years. Chatsworth later became famous for its Old West movie ranches and Stoney Point. After the late 1800s farming era, the post-WWII aerospace boom brought explosive growth, turning it into the proud, family-oriented suburban community it is today.'
}, {
  question: 'What are the demographics and lifestyle like in 91311?',
  answer: "It's prime family-raising territory. The median age is around 42, and the median household income is strong. With a high owner-occupancy rate, it's a community of people who invest in their homes and expect the area to stay well-maintained. The Mediterranean climate makes it perfect for outdoor living."
}, {
  question: 'What are the best ways to add value to a home here?',
  answer: 'Many homes in 91311 were built between the 1960s and 1990s, meaning they have great bones but need modernizing. The highest ROI upgrades right now are kitchen and bath remodels, expanding outdoor living spaces, and adding ADUs (Accessory Dwelling Units) for multi-generational living or rental income.'
}, {
  question: 'How are the local schools and parks?',
  answer: 'Excellent. The local schools are highly rated. Chatsworth Park South and Santa Susana Pass State Historic Park provide incredible trails, sports fields, and open space, making it a massive draw for families.'
}, {
  question: 'What is your mission as a realtor in 91311?',
  answer: "My mission is simple: help families maintain and improve their personal residences so the whole community stays strong. I act as a facilitator—whether it's navigating the tax angles of improvements, executing smart upgrades, or positioning homes to protect equity and build long-term wealth."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-32 bg-gray-50" data-id="element-111">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-113">
          <h2 className="text-sm font-bold tracking-widest text-brand-gold uppercase mb-4" data-id="element-114">
            Community Knowledge
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6" data-id="element-115">
            91311 Neighborhood FAQ
          </h3>
          <p className="text-gray-600 text-lg leading-relaxed" data-id="element-116">
            Everything you need to know about the history, lifestyle, and real
            estate opportunities in Chatsworth.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-117">
          {faqs.map((faq, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} key={index} className="bg-white border border-gray-200 rounded-3xl overflow-hidden transition-all duration-300 hover:border-brand-gold/50 hover:shadow-lg shadow-sm" data-id="element-118">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} className="w-full px-8 py-6 flex justify-between items-center text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-gold rounded-3xl" data-id="element-119">
                <span className="font-medium text-gray-900 text-lg pr-8" data-id="element-120">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center flex-shrink-0" data-id="element-121">
                  <ChevronDown className={`w-5 h-5 ${openIndex === index ? 'text-brand-gold' : 'text-gray-400'}`} data-id="element-122" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-123">
                {openIndex === index && <motion.div id={`faq-answer-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-124">
                    <div className="px-8 pb-8" data-id="element-125">
                      <p className="text-gray-600 font-light text-lg leading-relaxed border-t border-gray-100 pt-6" data-id="element-126">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}